import script from "./ProjectSmeta.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectSmeta.vue?vue&type=script&setup=true&lang=js"

import "./ProjectSmeta.vue?vue&type=style&index=0&id=5c5eecfc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c5eecfc"]])

export default __exports__
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLinearProgress,QTr,QTh,QTooltip});
